import { useContext } from "react";
import { Schedule } from './schedule';
import { UserContext } from "../../pages/user/user-settings";

export const UnsocialHours = () => {

    const { myProfile, setMyProfile } = useContext(UserContext);

    const canAdd = () => myProfile.unsocialHours.doNotDuringRanges.length < 3;

    const handleScheduleChange = (schedule, counter) => {
        const updatedProfile = structuredClone(myProfile);
        updatedProfile.unsocialHours.doNotDuringRanges.splice(counter, 1, schedule);
        setMyProfile(updatedProfile);
    };

    const add = () => {
        if (canAdd()) {
            const updatedProfile = structuredClone(myProfile);
            updatedProfile.unsocialHours.doNotDuringRanges.push({
                days: [0, 1, 2, 3, 4, 5, 6],
                start: "20:00:00",
                end: "09:00:00"
            });
            setMyProfile(updatedProfile);
        }
    };

    return !!myProfile && (
        <>

            {myProfile && myProfile.unsocialHours && Array.isArray(myProfile.unsocialHours.doNotDuringRanges) && myProfile.unsocialHours.doNotDuringRanges.map((schedule, counter) =>
                <Schedule
                    key={`schedule-${counter}`}
                    schedule={schedule}
                    counter={counter}
                    onChange={newValue => handleScheduleChange(newValue, counter)}
                />
            )}

            {canAdd() && <div className="row ps-2 pe-2 mt-2" >
                <button onClick={add} className="btn btn-primary">
                    <i className="fa fa-plus"></i> Add
                </button>
            </div>}

        </>
    );
};